import { reportDigitalInventoryTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_DIGITAL_INVENTORY_FILTERS, RESTORE_INITIAL } = reportDigitalInventoryTypes;

const initialState = {
  date: newDate(),
  station: null,
};

export const reportDigitalInventoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {

    case SET_REPORT_DIGITAL_INVENTORY_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState

    default:
      return state;
  }
};